import { render, staticRenderFns } from "./OnboardingDateSelector.vue?vue&type=template&id=e88f70ec&scoped=true&"
import script from "./OnboardingDateSelector.vue?vue&type=script&lang=js&"
export * from "./OnboardingDateSelector.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDateSelector.vue?vue&type=style&index=0&id=e88f70ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88f70ec",
  null
  
)

export default component.exports